<template>
  <el-main class="container">
    <Nav>
      <div class="left" slot="left">
        <div class="status">
            <span>类型筛选</span>
            <el-select
              slot="prepend"
              class="select"
              clearable
              v-model="selectStatus"
              placeholder="选择轮播图类型"
              @change="event().selectType($event)">
              <el-option
                  v-for="(item,index) in BannerStatus"
                  :key="index"
                  :value="item"></el-option>
            </el-select>
        </div>
      </div>
      <div class="right" slot="right">
        <el-button v-show="hasAuthority('addCarousel')" type="primary" @click="handlerRouter('add')">新增轮播图</el-button>
      </div>
    </Nav>
    <table-pagination
      ref="table"
      :config="config"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="500"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-link
              v-if="scope.row.status === 1"
              v-show="hasAuthority('showCarousel')"
              type='primary'
              :underline="false"
              class="details"
              @click="handlerShow( scope)">
              隐藏</el-link>
            <el-link
              v-if="scope.row.status === 0"
              v-show="hasAuthority('showCarousel')"
              type='primary'
              :underline="false"
              class="details"
              @click="handlerShow( scope)">
              显示</el-link>
            <el-link
              v-show="hasAuthority('editCarousel')"
              style="margin-left: 5px"
              type='primary'
              :underline="false"
              class="details"
              @click="handlerRouter('set', scope)">
              编辑</el-link>
            <el-link
              v-show="hasAuthority('deleteCarousel')"
              style="margin-left: 5px"
              :underline="false"
              type='primary'
              class="details"
              @click="event().delete(scope)">
              删除</el-link>
          </div>
        </template>
      </el-table-column>
    </table-pagination>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
import TablePagination from '@/components/table-pagination'
import { getCarouselList, deleteCarouse, updateCarouse } from '@/api/basic'
export default {
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 1,
        type: '',
        industryUuid: ''
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'indexNum',
            label: '排列序号'
          },
          {
            prop: 'picture',
            label: '轮播图片',
            type: 'image',
            width: '450',
            imgH: '160',
            imgW: '160'
          },
          {
            prop: 'type',
            label: '类型',
            type: 'status',
            rule: [
              {
                value: 0,
                label: '停车缴费'
              },
              {
                value: 1,
                label: '企业服务'
              },
              {
                value: 2,
                label: '首页'
              }
            ]
          },
          {
            prop: 'industryName',
            label: '关联产业'
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      },
      selectStatus: '',
      BannerStatus: ['停车缴费', '企业服务', '物业服务']
    }
  },
  created() {
    this.network().getCarouselList()
  },
  methods: {
    event() {
      return {
        selectType: (e) => {
          if (e === this.BannerStatus[0]) {
            this.body.type = 0
          } else if (e === this.BannerStatus[1]) {
            this.body.type = 1
          } else if (e === this.BannerStatus[2]) {
            this.body.type = 2
          } else this.body.type = ''
          this.network().getCarouselList()
        },
        delete: (scope) => {
          this.$confirm('是否删除该轮播图？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.network().deleteCarouse(scope.row.uuid)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        },
      }
    },
    network() {
      return {
        getCarouselList: async() => {
          const { data } = await getCarouselList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        deleteCarouse: async(uuid) => {
          await deleteCarouse(uuid)
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.network().getCarouselList()
        },
        updateCarouse: async(uuid)=>{
          await updateCarouse(uuid)
          this.$message.success('更新成功')
          this.network().getCarouselList()
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getCarouselList()
    },
    handlerRouter(type, scope) {
      if (type === 'set') {
        this.$router.push({
          path: `carousel/set/${scope.row.uuid}`,
          query: { info: scope.row }
        })
      } else if (type === 'add') {
        this.$router.push('carousel/add')
      }
    },
    handlerShow(scoped){
      this.network().updateCarouse(scoped.row.uuid)
    }
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
.container{
  Nav{
    margin-bottom: 15px;
    .select{
      margin-left: 15px;
    }
  }
}
</style>
